"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLOW_CHANGE_FLOW_TYPE = void 0;
const FLOW_CHANGE_FLOW_TYPE = exports.FLOW_CHANGE_FLOW_TYPE = 'flow/changeFlow';